import { ACCOUNT_STATUSES_BLOCKING_ORDERS, UserRole, isDistributorRole } from '@lombok/shared';
import { useDistributor } from '@/data/hooks';
import { useAuth } from './AuthContext';
import { useSessionProfile } from './useSessionProfile';

/**
 * Finance reads orders and quotes but cannot create them (the API answers 403), so screens hide
 * the "Crear pedido" / "Crear cotización" buttons from it. A distributor can create orders only while its own account
 * is not suspended, rejected or closed (and not until that is known). A UX gate only: the backend stays the authority.
 */
export function useCanCreateOrders(): boolean {
  const { session } = useAuth();
  const { profile } = useSessionProfile();
  const role = session?.user.role;
  const isDistributor = role ? isDistributorRole(role) : false;
  // The account is only read for distributor users; the query stays off for everyone else.
  const distributor = useDistributor(isDistributor ? profile?.distributorId : undefined).data;
  if (!role) return false;
  if (isDistributor) return distributor ? !ACCOUNT_STATUSES_BLOCKING_ORDERS.includes(distributor.status) : false;
  return role !== UserRole.FINANCE;
}
